class SiteHistory {

    _historyEvent: QueryEventAsync<string>;
    get historyEvent(){ return this._historyEvent.expose(); } 

    constructor() {
        this._historyEvent = new QueryEventAsync<string>();

        window.addEventListener("popstate", (e: PopStateEvent) => {
            this._historyEvent.trigger("");
        }, false);
    }

    add() {
        history.pushState({}, "");
    }
}